import { API_AUTH, API_AUTH_API, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain, getUserLogin } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
    token = token.substring(6);
    setTokenGlobal(token, urlNew);
}
export default {

    chiTietDonHang: (orderdathangId) => {
        return API_AUTH.get(`dathang/GetDonHangByOrderDatHangID?orderdathangId=${orderdathangId}`, {});
    },

    getOptionForOrder: (optionId, categoryId, branchId) => {
        return API_AUTH.get(
            `dathang/GetOptionForOrder?optionId=${optionId}&categoryId=${categoryId}&branchId=${branchId}`,
            {}
        );
    },

    getDanhSachTinhThanh: (TinhThanhId) => {
        return API_AUTH.get(`dathang/GetTinhThanh?TinhThanhId=${TinhThanhId}`, {});
    },

    AutocompleteSanPham: (tukhoa) =>
        API_AUTH.get(`dathang/SearchCategory${tukhoa.params}`, {}),
    getChiTietSanPhamById: (
        iCategoryID,
        iStore,
        iBranch,
        CustomerId,
        NgayBan
    ) => {
        return API_AUTH.get(
            `dathang/GetChiTietByCategoryID?iCategoryID=${iCategoryID}&iStore=${iStore}&iBranch=${iBranch}&CustomerId=${CustomerId}&NgayBan=${NgayBan}`,
            {}
        );
    },


    getChiTietKhachHangById: (userdaily) => {
        return API_AUTH.get(
            `dathang/getKhachHangById?userdaily=${userdaily}`,
            {}
        );
    },

    addOrUpdateDatHang: (params) =>
        API_AUTH.post(
            "dathang/addOrUpdateDatHang?sUserName=" + params.sUserName,
            params
        ),

    addOrUpdateDatHangNgoai: (params) =>
        API_AUTH.post(
            "dathang/addOrUpdateDatHangNgoai?sUserName=" + params.sUserName,
            params
        ),

    list: ({
        tuNgay,
        denNgay,
        sSearch,
        sUserName,
        sCustomerName,
        iTrangThaiTruKho,
        iTrangThaiThanhToan,
        iBranch,
        sBranch,
        sNVKDUserName,
        lstNhomKH,
        iLoaiDon,
        iLoaiDoiTac,
        iPageIndex,
        iPageSize,
        TinhThanhPhoId,
        QuanhuyenId,
        PhuongxaId,
        sTrangThai
    }) =>
        API_AUTH.get(
            `dathang/DanhSachDonDatHang?fromDate=${tuNgay}&toDate=${denNgay}&sSearch=${sSearch}&sUserName=${sUserName}&sCustomerName=${sCustomerName}&iTrangThaiTruKho=${iTrangThaiTruKho}&iTrangThaiThanhToan=${iTrangThaiThanhToan}&iBranch=${iBranch}&sBranch=${sBranch}&sNVKDUserName=${sNVKDUserName}&lstNhomKH=${lstNhomKH}&iLoaiDon=${iLoaiDon}&iLoaiDoiTac=${iLoaiDoiTac}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&TinhThanhPhoId=${TinhThanhPhoId}&QuanhuyenId=${QuanhuyenId}&PhuongxaId=${PhuongxaId}&sTrangThai=${sTrangThai}`,
            {}
        ),

    GetChiTietDonHangHienThiByOrderId: (OrderID) => {
        return API_AUTH.get(
            `dathang/GetChiTietDonHangHienThiByOrderId?OrderID=${OrderID}`,
            {}
        );
    },


    GetChiTietDonHangCuaDatHangHienThiByOrderId: (OrderID) => {
        return API_AUTH.get(
            `dathang/GetChiTietDonHangCuaDatHangHienThiByOrderId?OrderID=${OrderID}`,
            {}
        );
    },

    xoaDonhang: (OrderID, sUserName, Note) => {
        return API_AUTH.post(
            `dathang/XoaDonHang?OrderID=${OrderID}&sUserName=${sUserName}&Note=${Note}`,
            {}
        );
    },

    InDanhSachDonDatHang: (
        fromDate,
        toDate,
        sSearch,
        sUserName,
        sCustomerName,
        iTrangThaiTruKho,
        iTrangThaiThanhToan,
        iBranch,
        sBranch,
        sNVKDUserName,
        lstNhomKH,
        iLoaiDon,
        iLoaiDoiTac,
        iPageIndex,
        iPageSize,
        TinhThanhPhoId,
        QuanhuyenId,
        PhuongxaId,
        sTrangThai
    ) =>
        API_AUTH.get(
            `dathang/InDanhSachDonHang?fromDate=${fromDate}&toDate=${toDate}&sSearch=${sSearch}&sUserName=${sUserName}&sCustomerName=${sCustomerName}&iTrangThaiTruKho=${iTrangThaiTruKho}&iTrangThaiThanhToan=${iTrangThaiThanhToan}&iBranch=${iBranch}&sBranch=${sBranch}&sNVKDUserName=${sNVKDUserName}&lstNhomKH=${lstNhomKH}&iLoaiDon=${iLoaiDon}&iLoaiDoiTac=${iLoaiDoiTac}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&TinhThanhPhoId=${TinhThanhPhoId}&QuanhuyenId=${QuanhuyenId}&PhuongxaId=${PhuongxaId}&sTrangThai=${sTrangThai}`,
            {}
        ),



    PrintChiTietDonHangDaiLy: (OrderID, MauIn, ConfigCkCongThuc) => {
        return API_AUTH.post(
            `dathang/PrintChiTietDonHangDaiLy?OrderID=${OrderID}&MauIn=${MauIn}&ConfigCkCongThuc=${ConfigCkCongThuc}`,
            {}
        );
    },


    PrintChiTietDonHang: (OrderID, MauIn, ConfigCkCongThuc) => {
        return API_AUTH.post(
            `dathang/PrintChiTietDonHang?OrderID=${OrderID}&MauIn=${MauIn}&ConfigCkCongThuc=${ConfigCkCongThuc}`,
            {}
        );
    },



    PrintChiTietDonHangGuiNCC: (code) => {
        return API_AUTH.post(
            `dathang/PrintChiTietDonHangGuiNCC?code=${code}`,
            {}
        );
    },

    //--------------------------------------------------------------------------------













    // addOrUpdateBanHang: (params) =>
    //   API_AUTH.post("banhang/addOrUpdateBanHang", params),
    getBanHangById: (params) =>
        API_AUTH.get("banhang/getBanHangPrint?OrderID=" + params),
    Autocomplete: (tukhoa) =>
        API_AUTH.get(`khachhang/getKhachHang${tukhoa.params}`, {}),




    GetGiaVaTonKhoByCategoryID: (CategoryID, iStore, NgayBan, isLayHoaDon) => {
        return API_AUTH.get(
            `banhang/GetGiaVaTonKhoByCategoryID?CategoryID=${CategoryID}&iStore=${iStore}&NgayBan=${NgayBan}&isLayHoaDon=${isLayHoaDon}`,
            {}
        );
    },
    GetChiTietDonHangByLoaiPBCNId: (OrderId, LoaiPBCNID) => {
        return API_AUTH.get(
            `banhang/GetChiTietDonHangByLoaiPBCNId?OrderID=${OrderId}&LoaiPBCNID=${LoaiPBCNID}`,
            {}
        );
    },
    AutocompleteMaCuon: (tukhoa) =>
        API_AUTH.get(`banhang/GetListMaCuonByCateID${tukhoa.params}`),




    chiTietDonHangTaoLSX: (OrderID) => {
        return API_AUTH.get(
            `banhang/GetDonHangTaoLSXByOrderId?OrderID=${OrderID}`,
            {}
        );
    },
    chiTietDonHangTaoLSXQuyTrinh: (OrderID) => {
        return API_AUTH.get(
            `banhang/GetDonHangTaoQuyTrinhByOrderId?OrderID=${OrderID}`,
            {}
        );
    },

    GetChiTietDonHangHienThiByOrderCode: (OrderCode) => {
        return API_AUTH.get(
            `banhang/GetChiTietDonHangHienThiByOrderCode?OrderCode=${OrderCode}`,
            {}
        );
    },
    addOrUpdateBanHangChoDuyet: (params) =>
        API_AUTH.post(
            "banhang/saveBanHangChoDuyet?sUserName=" + params.sUserName,
            params
        ),
    getFullRole: (username) => {
        return API_AUTH.get(`users/getAllRoleInUser?username=${username}`, {});
    },
    getListNVKD: (UserName) => {
        return API_AUTH.get(
            `NhanVienKinhDoanh/GetNhanVienKinhDoanhByUserName?UserName=${UserName}`,
            {}
        );
    },

    thanhToanDonHang: (OrderID, SoTien, iLoaiGiaoDich, sUserName, Note) => {
        return API_AUTH.post(
            `banhang/ThanhToanDonHang?OrderID=${OrderID}&SoTien=${SoTien}&iLoaiGiaoDich=${iLoaiGiaoDich}&sUserName=${sUserName}&Note=${Note}`,
            {}
        );
    },
    getChiTietLichSuSua: (OrderID) => {
        return API_AUTH.get(`banhang/LichSuSuaDonHang?OrderID=${OrderID}`, {});
    },
    createLenhSanXuatTuDonBanHang: (OrderID) => {
        return API_AUTH.get(
            `banhang/TaoLenhSanXuatTuDonBanHang?OrderID=${OrderID}`,
            {}
        );
    },
    saveGiaoNhan: (OrderID, isGiaoNhan) => {
        return API_AUTH.post(
            `banhang/SaveGiaoNhan?OrderID=${OrderID}&isGiaoNhan=${isGiaoNhan}&userName=${getUserLogin().UserName
            }`,
            {}
        );
    },
    listInNhanh: (lstOrderID) => {
        return API_AUTH.get(
            `banhang/PrintNhanhDonHang?lstOrderID=${lstOrderID}`,
            {}
        );
    },
    listInNhanhChoXuatKho: (lstOrderID) => {
        return API_AUTH.get(
            `banhang/PrintDonChoXuatKho?lstOrderID=${lstOrderID}`,
            {}
        );
    },
    inPhieuXuatKho: (lstOrderID, iBranch) => {
        return API_AUTH.get(
            `banhang/LoadThongTinExportTruKho?exportId=${lstOrderID}&iBranch=${iBranch}`,
            {}
        );
    },
    listInLenhCat: (lstOrderID) => {
        return API_AUTH.get(
            `banhang/PrintPhieuLenhCat?lstOrderID=${lstOrderID}`,
            {}
        );
    },
    addYeuCauChoDuyet: (OrderID, Note, sUserName) => {
        return API_AUTH.post(
            `banhang/SaveYeuCauChoDuyet?OrderID=${OrderID}&Note=${Note}&sUserName=${sUserName}`,
            {}
        );
    },


    checkCanhBaoDonHang: (params) => {
        return API_AUTH.post(`banhang/kiemTraTrungDon`, params);
    },

    getListNVKDNew: (tenNhanVien, iBranch, pageIndex, pageSize) => {
        return API_AUTH.get(
            `nhanvienkd/DanhSachNhanVienKinhDoanh?tenNhanVien=${tenNhanVien}&iBranch=${iBranch}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
            {}
        );
    },

    postKiemTraThucTon: (params) => {
        console.log("paramsparamsparams", params);
        return API_AUTH.post(
            `banhang/kiemTraThucTon`, params);
    },



};
